import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import MainView from './views/main';
import './App.css';

class App extends Component {
  render() {
    return (
      <Router>
        <div className='main_container'>

          <Container className='content_container'>
            <Route exact path='/' component={MainView} />
          </Container>

          <Container className='allns_footer'>
            <Row className='justify-content-center'>
              Copyright &copy; {`${(new Date()).getFullYear()} `}
              All Business Online News Group Ltd.
              All rights reserved.
            </Row>
            <Row className='justify-content-center'>
              <a
                href="https://allnovascotia.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              <a
                style={{ marginLeft: '1em' }}
                href="https://allnovascotia.com/help"
                target="_blank"
                rel="noopener noreferrer"
              >
                Support
              </a>
            </Row>
          </Container>
        </div>
      </Router>
    );
  }
}

export default App;
